import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PostHooks from "../../../Hooks/PostHooks";
import UpdateHooks from "../../../Hooks/UpdateHooks";
import { Icon } from "@iconify/react";
import { useQuery } from "../../../Hooks/useApi";

const SuperAdminSteps = () => {
  const { data: stepsResponse } = useQuery("/steps/getSteps");
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    firstStepsTitle: "",
    firstStepsDes: "",
    secondStepsTitle: "",
    secondStepsDes: "",
    thirdStepsTitle: "",
    thirdStepsDes: "",
  });

  useEffect(() => {
    if (stepsResponse?.data?.length) {
      setFormData(stepsResponse.data[0]);
    }
  }, [stepsResponse]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (formData?._id) {
        await UpdateHooks(
          `https://servercareseebd.careseebd.com/api/v1/steps/updateSteps/${formData?._id}`,
          formData
        );
        toast.success("Steps updated successfully!");
      } else {
        await PostHooks(
          `https://servercareseebd.careseebd.com/api/v1/steps/addSteps`,
          formData,
          "steps data posted"
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="max-w-5xl mx-auto select-none space-y-6">
      {/* Header bar */}
      <div className="flex items-center gap-3 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
        <div className="p-3 bg-indigo-50 text-indigo-600 rounded-xl">
          <Icon icon="solar:route-line-bold" className="w-6 h-6" />
        </div>
        <div>
          <h1 className="text-lg font-black text-slate-800 tracking-tight">Onboarding Steps Settings</h1>
          <p className="text-xs text-slate-400 font-semibold mt-0.5">Edit step-by-step walk-through sections of the site</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Main section settings */}
        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 lg:p-8 space-y-4">
          <h2 className="text-xs font-black text-slate-400 uppercase tracking-wider flex items-center gap-1.5">
            <Icon icon="solar:document-bold" className="w-4 h-4 text-indigo-500" />
            General Information
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="space-y-1.5 sm:col-span-2">
              <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Section Name</label>
              <input
                type="text"
                name="title"
                required
                onChange={handleChange}
                value={formData.title}
                placeholder="e.g. Simple Onboarding Process"
                className="w-full px-3 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-semibold text-slate-800"
              />
            </div>
            <div className="space-y-1.5 sm:col-span-2">
              <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Section Description</label>
              <textarea
                name="description"
                required
                rows="3"
                onChange={handleChange}
                value={formData.description}
                placeholder="Explain the step process brief..."
                className="w-full px-3 py-2 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-medium text-slate-800"
              />
            </div>
          </div>
        </div>

        {/* Feature Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { num: "first", titleLabel: "First Step Title", descLabel: "First Step Description", titleName: "firstStepsTitle", descName: "firstStepsDes" },
            { num: "second", titleLabel: "Second Step Title", descLabel: "Second Step Description", titleName: "secondStepsTitle", descName: "secondStepsDes" },
            { num: "third", titleLabel: "Third Step Title", descLabel: "Third Step Description", titleName: "thirdStepsTitle", descName: "thirdStepsDes" }
          ].map((card, i) => (
            <div key={i} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 space-y-4">
              <h3 className="text-xs font-black text-slate-400 uppercase tracking-wider flex items-center gap-1.5">
                <span className="w-5 h-5 rounded-full bg-cyan-500 text-white font-extrabold flex items-center justify-center text-[10px]">{i + 1}</span>
                Step #{i + 1} Details
              </h3>
              <div className="space-y-3">
                <div className="space-y-1.5">
                  <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wide">{card.titleLabel}</label>
                  <input
                    type="text"
                    name={card.titleName}
                    required
                    onChange={handleChange}
                    value={formData[card.titleName] || ""}
                    placeholder="Enter step title"
                    className="w-full px-3 py-2 rounded-xl border border-slate-180 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-bold text-slate-800"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wide">{card.descLabel}</label>
                  <textarea
                    name={card.descName}
                    required
                    rows="3.5"
                    onChange={handleChange}
                    value={formData[card.descName] || ""}
                    placeholder="Describe this step..."
                    className="w-full px-3 py-2 rounded-xl border border-slate-180 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-medium text-slate-700"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Submit */}
        <div className="pt-2">
          <button
            type="submit"
            className="w-full py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 hover:opacity-95 text-white font-extrabold text-xs rounded-xl shadow-md shadow-cyan-500/10 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer"
          >
            Update Onboarding Steps
          </button>
        </div>
      </form>
    </div>
  );
};

export default SuperAdminSteps;
